<template>
  <div class="speed-legend">
    <span class="speed-legend-label">Slow</span>
    <span
      v-for="(color, index) in colors"
      :key="color"
      class="speed-legend-chip-wrap"
      @mouseenter="hovered = index"
      @mouseleave="hovered = null"
    >
      <span class="speed-legend-chip" :style="{ background: color }"></span>
      <span v-if="hovered === index && label" class="speed-legend-value">{{ label }}</span>
    </span>
    <span class="speed-legend-label">Fast</span>
  </div>
</template>

<script>
import {
  SPEED_COLORS, speedBuckets, bucketColors, speedBounds, bucketLabel,
} from '@/util/trail/trailColor';
import { kmhToKnot } from '@/util/units';

export default {
  name: 'SpeedLegend',
  props: {
    // km/h
    speeds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      hovered: null,
      colors: SPEED_COLORS,
    };
  },
  computed: {
    // logika sama dgn legend Map Viewer
    label() {
      if (this.hovered === null) return '';
      const bounds = speedBounds(this.speeds).map((value) => kmhToKnot(value));
      if (bounds.length === 0) return 'No speed data';
      const bucket = bucketColors(speedBuckets(this.speeds)).indexOf(SPEED_COLORS[this.hovered]);
      return bucket === -1 ? 'Not in this range' : `${bucketLabel(bucket, bounds)} kn`;
    },
  },
};
</script>

<style scoped>
.speed-legend {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  font-size: 12.25px;
  color: #455a64;
}

.speed-legend-chip-wrap {
  position: relative;
  display: inline-flex;
}

.speed-legend-chip {
  width: 14px;
  height: 10px;
  border-radius: 2px;
}

.speed-legend-value {
  position: absolute;
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  padding: 2px 6px;
  background: #212529;
  color: #fff;
  border-radius: 4px;
  font-size: 12.25px;
}

@media (max-width: 767.98px) {
  .speed-legend-chip {
    width: 10px;
    height: 8px;
  }
}
</style>
